<template>
<div class="drawerWrap">
  <div class="drawerBody">
    <el-form ref="form" :model="form" :rules="formRules" label-position="right" label-width="120px">
      <el-form-item label="故障内容" prop="content">
        <el-input type="textarea" v-html="dealDialogPar.row.content"></el-input>
      </el-form-item>
      <el-form-item label="处理类型" prop="type">
        <el-select v-model="form.type" placeholder="请输入处理类型" clearable>
          <el-option v-for="(item,i) in dealType" :key="i" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理描述" prop="describe">
          <el-input type="textarea" v-model="form.describe" placeholder="请输入处理描述" maxlength="80"></el-input>
      </el-form-item>
    </el-form>
  </div>
  <div class="drawerFoot">
    <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
    <el-button @click="cancelHandle()">取 消</el-button>
  </div>
</div>
</template>

<script>
export default {
  
  props: {
    dealDialogPar:{
      type:Object,
      default:()=>({})
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      form: {
        type: null,
        describe: null
      },
      dealType: [{
          value: 1,
          label: '报废'
        },
        {
          value: 2,
          label: '维修中'
        },
        {
          value: 3,
          label: '已完成'
        },
        {
          value: 4,
          label: '撤销'
        },
      ],
      formRules: {
        type: [{
          required: true,
          message: "请选择处理类型",
          trigger: "change"
        }],
        describe: [{
          required: true,
          validator: this.validateDescribe,
          trigger: "change"
        }],
      },
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    cancelHandle() { //取消
      this.$emit("cancel", false);
    },
    confirmHandle() {
      console.log(`this.form`, this.form)
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }
        let par = {id:this.dealDialogPar.row.id,type:this.form.type,describe:this.form.describe}
        this.$emit("update:loading", true);
        this.request.postParamsData("/front/fault/record/handle", par).then(rs => {
          this.$emit("update:loading", false);
          if (rs.code === 200) {
            this.msg.success('处理成功')
            this.$emit('confirm', rs.code)
          } else if (rs.code == 500) {
            this.msg.warn(rs.msg);
          }
        });
      });
    },
    validateDescribe(rule, value, callback) {
      if ( value === null || value.length === 0) {
        callback(new Error("处理描述不能为空"));
      } else {
        callback();
      }
    },
  }
};
</script>

<style lang="scss">
.drawerWrap {
  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 250px;
    }

    .el-transfer__buttons {
      width: 65px;
      text-align: center;

      .el-button {
        margin: 5px 0;
        width: 56px;
      }
    }
  }

  .el-switch {
    width: 100%;
  }

  .el-image {
    margin-right: 20px;
  }

  .el-form {
    margin-top: 20px;

    .el-form-item__label {
      line-height: 50px;
    }

    .el-form-item__content {
      line-height: 50px;
    }

    .el-select {
      width: 100%;
    }

    .el-textarea {
      width: 270px;

      .el-textarea__inner {
        height: 100px !important;
        line-height: 20px;
        color: #6e6e6e;
        font-size: 14px;
      }
    }

    .el-input {
      width: 270px;

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .drawerBody .el-form-item__label,
  .sp {
    color: #6e6e6e;
  }

}
</style>
